module.exports = __webpack_public_path__ + "img/check-white.c1318626.svg";